import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import React from "react";

interface ExplorerNavigatorProps {
  currentIndex: number;
  totalCount: number;
  onPrevious: () => void;
  onNext: () => void;
}

const FIRST_ITEM_INDEX = 0;
const DISPLAY_OFFSET = 1;
const MIN_ITEMS_FOR_NAVIGATION = 1;

const ExplorerNavigator: React.FC<ExplorerNavigatorProps> = ({
  currentIndex,
  totalCount,
  onPrevious,
  onNext
}) => {
  const isFirstItem = currentIndex === FIRST_ITEM_INDEX;
  const isLastItem = currentIndex === totalCount - DISPLAY_OFFSET;

  if (totalCount <= MIN_ITEMS_FOR_NAVIGATION) {
    return null;
  }

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      <Tooltip title="Previous">
        <span>
          <IconButton
            onClick={onPrevious}
            disabled={isFirstItem}
            size="small"
            color="primary"
            aria-label="previous item"
          >
            <ChevronLeftIcon />
          </IconButton>
        </span>
      </Tooltip>
      <Typography
        variant="body2"
        sx={{ minWidth: "80px", textAlign: "center", color: "text.secondary", fontWeight: 500 }}
      >
        {currentIndex + DISPLAY_OFFSET} of {totalCount}
      </Typography>
      <Tooltip title="Next">
        <span>
          <IconButton
            onClick={onNext}
            disabled={isLastItem}
            size="small"
            color="primary"
            aria-label="next item"
          >
            <ChevronRightIcon />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
};

export default ExplorerNavigator;
